<template>
  <section class="panel">
    <div class="fading">
      <h1>Create a new memorial - Step 2 of 3</h1>
      <div class="text">
        <div v-html="text.new_step_2" v-if="text"></div>
        <p v-if="examples && examples.length">
          Not sure what to write? View
          <a @click.prevent="$modal.show('examples')" href>some completed examples here</a>
        </p>
      </div>
      <div class="designer">
        <div class="designer-left">
          <textarea name="editor1" v-model="inscription_text"></textarea>
          <div class="note">
            <p>
              We typically use two different font styles on all our memorials, we recommend using Zaph Chancery Demi for
              the opening header (in loving memory of) and also for the closing verse (Remembered with a smile).
            </p>

            <p>
              The remaining text should be set in Goudy old style bold, but should you wish for an alternative we will
              try our best to accommodate this.
            </p>

            <p>
              Please use the text editor above and we will discuss further options with you once we receive your
              enquiry.
            </p>
          </div>
        </div>
        <div :class="shape.value == 'Heart' ? 'heart' : ''" class="designer-right" id="canvasholder">
          <preview :inscription_text="inscription_text"></preview>
        </div>
      </div>

      <div class="actions">
        <button @click="$router.push('new')" class="button back">Back</button>
        <!--<button
          v-if="introduction && name && known && dates && sentiment && closing"
          @click="$router.push('extras')"
          class="button"
        >
          Continue
          <pulse></pulse>
        </button>-->
        <!--<button
          @click="next"
          class="button"
          v-if="inscription_text && inscription_text != $store.state.starter_inscription && inscription_text.indexOf($store.state.starter_name) == -1"
        >
          Continue
          <pulse></pulse>
        </button>-->
        <button @click="next" class="button">
          Continue
          <pulse></pulse>
        </button>
      </div>
    </div>

    <modal :scrollable="true" height="auto" name="examples" width="90%">
      <a @click.prevent="$modal.hide('examples')" class="modal-close" href>
        <font-awesome-icon icon="times" />
      </a>
      <div class="modal-grid">
        <div>
          <h2>Examples of completed memorials</h2>
          <div class="examples">
            <slide-show :speed="100000" @slide-change="examplesslidenumber = $event" ref="slideshow">
              <img :key="i" :src="example.image" v-for="(example, i) in examples" />
            </slide-show>
            <div class="controls" v-if="examples && examples.length > 1">
              <a
                @click.prevent="
                  $refs.slideshow.show(examplesslidenumber > 1 ? examplesslidenumber - 1 : examples.length)
                "
                aria-label="Previous"
                class="prev"
                href
              >
                <font-awesome-icon icon="chevron-left" />
              </a>
              <a
                @click.prevent="
                  $refs.slideshow.show(examplesslidenumber < examples.length ? examplesslidenumber + 1 : 1)
                "
                aria-label="Next"
                class="next"
                href
              >
                <font-awesome-icon icon="chevron-right" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </modal>
  </section>
</template>

<script>
import Pulse from "@/components/Pulse.vue"
import Preview from "@/components/Preview.vue"
export default {
  data() {
    return {
      modal: {},
      examplesslidenumber: 1,
      inscription_text: ""
    }
  },
  components: {
    Pulse,
    Preview
  },
  created() {
    this.inscription_text = this.$store.state.inscription_text
    this.initialiseCK()
  },
  computed: {
    text() {
      return this.$store.state.text
    },
    shape() {
      return this.$store.state.style.shape || {}
    },
    examples() {
      return this.$store.state.examples
    }
  },
  methods: {
    next() {
      this.$store.commit("setInscriptionText", this.inscription_text)

      this.$router.push("summary")
    },
    initialiseCK() {
      this.$nextTick(() => {
        const ck4Config = {
          extraPlugins: "font,lineheight",
          contentsCss: "/ck/fonts.css",
          fontSize_sizes: "Small/1.2rem;Medium/1.6rem;Large/2rem",
          line_height: "Small/0.8;Medium/1.2;Large/1.6",
          colorButton_colors: "Relief/000,Gold/D4AF37,Silver/BEC2CB",
          colorButton_enableMore: false,
          colorButton_enableAutomatic: false,
          removePlugins: "elementspath,resize",
          height: "40rem",
          font_names: "Goudy Old Style Bold;Zaph Chancery Demi",
          toolbar: [["Font", "FontSize", "lineheight", "TextColor"], ["JustifyCenter"]]
        }
        window.CKEDITOR.plugins.addExternal("lineheight", "/ck/lineheight/plugin.js")
        window.CKEDITOR.replace("editor1", ck4Config)
        window.CKEDITOR.on("instanceReady", () => {
          window.CKEDITOR.instances["editor1"].on("blur", () => {
            let ckeditorData = window.CKEDITOR.instances["editor1"].getData()
            this.inscription_text = ckeditorData
          })
          window.CKEDITOR.instances["editor1"].on("change", () => {
            let ckeditorData = window.CKEDITOR.instances["editor1"].getData()
            this.inscription_text = ckeditorData
          })
        })
      })
    }
  }
}
</script>

<style scoped>
.text {
  max-width: 125rem;
  margin: auto;
}

.examples {
  padding-top: 1rem;
}

.panel {
  text-align: center;
}
.background {
  width: 100%;
}
.designer {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 8rem;
  padding: 3rem 0;
  max-width: 125rem;
  margin: auto;
}
.designer-left {
  text-align: left;
}
.resources {
  display: none;
}
.spaced {
  padding-top: 2.5rem;
}
.spaced:first-child {
  border-top: 0;
  padding-top: 0;
}
.row {
  display: table;
  width: 100%;
}
.txt {
  width: 100%;
  padding: 0.7rem 1rem;
  border-radius: 0.5rem;
  border: 1px solid #ccc;
}
.option {
  font-size: 1.3rem;
  border: 1px solid #ccc;
  border-top: 0;
  padding: 0.25rem 0.5rem;
  border-bottom-left-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
  float: left;
  margin-left: 0.5rem;
  margin-bottom: 0.5rem;
  color: rgb(133, 133, 133);
}
.help {
  font-size: 1.5rem;
  padding: 0.25rem 1rem;
  float: right;
  margin-right: 0.5rem;
  color: rgb(133, 133, 133);
  transition: all 0.3s;
}
.help:hover {
  color: #b1ba22;
}

.suggestions {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 2rem;
  padding: 2rem 0;
}
.suggestions a {
  font-size: 1.5rem;
  background: #f5f5f5;
  padding: 1rem 1.5rem;
  transition: all 0.3s;
  border-radius: 0.5rem;
  line-height: 1.2;
}

.suggestions a:hover {
  background: rgb(226, 226, 226);
}
.text a {
  transition: all 0.3s;
}
.text a:hover {
  color: #006654;
}
.note {
  font-size: 1.2rem;
  opacity: 0.6;
}
@media screen and (max-width: 900px) {
  .help {
    border-radius: 0.5rem;
    margin-top: 1rem;
    margin-left: 0.5rem;
    white-space: nowrap;
  }
}
@media screen and (min-width: 1051px) {
  .designer-left {
    padding-top: 2rem;
  }
}
@media screen and (max-width: 1050px) {
  .designer {
    grid-template-columns: 1fr;
    grid-gap: 3rem;
  }
  .suggestions {
    grid-template-columns: 1fr;
  }
}
</style>
